import data from './data'
import methods from './methods'

export default {
  data,
  methods,
  /* route API for atient favorite-list */
  resourcePath: '/v1/patient/favorite-list'
}



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/resources/index.js